export default __webpack_public_path__ + "static/media/phaszr.4260c004.png";